import { EUserActions } from "../constants/user.constants";
import { IAction } from "../interfaces/action.interface";
import { IUser } from "../interfaces/user.interface";

export interface IUserReducer {
    user: IUser | undefined
}

const initialState : IUserReducer = {
    user: undefined,
};

const userReducer = (state:IUserReducer=initialState, action:IAction) : IUserReducer => {
    switch(action.type) {
        case EUserActions.SET_USER: {
            return { ...state, user: action.payload }
        }
        default: {
            return state; 
        }
    }
};

export { userReducer };